import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { apilink, path } from '../../data/fdata';
import './UnAuth.css';
const UnAuth = () => {
  const hecord_tokon = Cookies.get('_hecord_access_user_tokon_');
  const his = useHistory();
  useEffect(async () => {
    const res = await axios.get(`${apilink}/auth/isVerify`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (res.data.success) {
      his.push('/home');
    }
  }, []);

  return (
    <>
      <div className="whole_nav unauth_nav">
        <nav className="navbar navbar-expand-lg navbar-light bglight">
          <div className="dflex">
            <NavLink
              to="/"
              className="navbar-brand text-custom font-weight-bold dflex"
            >
              <img src={`${path}/image/logo.png`} alt="" className="logoimg" />
              <h2 className="logo_text">Hecord</h2>
            </NavLink>
          </div>

          <div>
            <NavLink to="/login" className="navitem">
              Login
            </NavLink>
            <NavLink to="/register" className="btn btn-primary">
              Register
            </NavLink>
          </div>
        </nav>
      </div>
      <div className="unauth_box">
        <img src="../image/doc.jpg" alt="" className="unauth_img" />
        <div className="unauth_box_green">
          <h1 className="text-light">HECORD</h1>
          <p className="text-light ">Store Your Medical Data in One Place </p>
          <NavLink to="/login" className="btn-blue ">
            Get Started
          </NavLink>
        </div>
      </div>

      <div className="small_box_unauth">
        <div className="small_inner_box">
          <h1 className="text-light">HECORD</h1>
          <p className="text-light">Store Your Medical Data in One Place </p>
          <NavLink to="/login" className="btn-blue">
            Get Started
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default UnAuth;
